export const settingsMenuData = [
    { name: 'User Profile', key: 'user_profile' },
    { name: 'User Account', key: 'user_account' },
    { name: 'User Verification', key: 'User_Verification' },
    { name: 'Default Currency', key: 'default_currency' },
    { name: 'Notification Settings', key: 'notification_topics' },
    { name: 'Device Tokens', key: 'device_tokens' },
]